import { Disclosure } from "@headlessui/react";
import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/outline";

const faqs = [
  {
    question: "How long will it take for the app to provide analytics?",
    answer:
      "We need one week's worth of data to start providing you with the analytics. We update the dashboard every Monday of the week.",
  },
  {
    question: "How to change my active plan?",
    answer:
      "Revisit the app by going to the Shopify app section in the admin page (cf-app-testing.myshopify.com/admin/apps) and click on CausalFunnel DataScience app. You will land on the main page with a “Change Plan” button. Click on this button and follow instructions on the page to change your plan.",
  },
  {
    question: "How to enable persona prediction?",
    answer:
      "To enable persona prediction and dashboard analytics corresponding to that visit the online theme and go to customize theme, then click on theme settings option and enable CausalFunnel DataScience app so that we can start tracking personas. Once enabled on the theme page, revisit our app from the admin page (cf-app-testing.myshopify.com/admin/apps). Once there, check the settings tab in the dashboard and the “persona prediction” should say “Enabled”.",
  },
  {
    question: "How to check details of my current activated plan?",
    answer:
      "To check details of your current plan, re-visit the app from Shopify admin/apps page. The first page will provide you with the information of your current plan.",
  },
  {
    question: "Will this app change my store's UI?",
    answer:
      "No, we will not change your store's UI. We don't make any kind of injections in your code. Our persona feature, if enabled, will just show a nudge which will float on top of your UI. You can see how it works on our listing page demo store.",
  },
  {
    question: "How to see the buying intent and persona nudges in action?",
    answer:
      "To see the buying intent and persona prediction in action, use the demo store link to navigate to the demo store. If the user browses some of the products and switches to a different tab without closing the current tab/browser and gets back to the tab (user inactive), CausalFunnel's AI on this demo store will judge you to have abandoned the website and will provide a popup to get you to buy. A recorded demo is also available here: buying intent and persona nudges demo. \n Note: The AI algorithm deployed on this demo store is a demo code that is a simpler version of our AI.",
  },
  {
    question: "How to enable persona nudges?",
    answer:
      "Once you buy the Enterprise Plan, please email us to set up your nudges offer, discount percentage, and coupon IDs for deployment on the store. Our team will get back in touch within 2-3 working days to set up the persona-based nudges for you.",
  },
  {
    question: "How to use the dashboard to improve ad campaigns?",
    answer:
      "You can launch multiple ad campaigns and use the 'marketing performance' tab in the dashboard to track and compare the visitors, add to cart, and final purchase numbers for different campaigns. In the Enterprise version of the plan, our team will also help you A/B test your different campaigns.",
  },
];


export default function Help() {
  return (
    <div className="mx-auto w-[75%] flex-grow px-6 py-5 sm:py-5 lg:px-8 lg:py-5">
      <div className="mx-auto w-full divide-y divide-gray-900/10">
        <h2 className="text-3xl font-bold leading-10 tracking-tight text-gray-900">
          Frequently asked questions
        </h2>
        <dl className="mt-8 space-y-6 divide-y divide-gray-900/10">
          {faqs.map((faq) => (
            <Disclosure as="div" key={faq.question} className="pt-3">
              {({ open }) => (
                <>
                  <dt>
                    <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                      <span className="text-xl font-semibold leading-7">
                        {faq.question}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        {open ? (
                          <MinusSmallIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        ) : (
                          <PlusSmallIcon
                            className="h-6 w-6"
                            aria-hidden="true"
                          />
                        )}
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2 pr-12">
                    <p className=" text-[17px] leading-7 text-gray-600">
                      {faq.answer}
                    </p>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </dl>
        <p className="text-xl mt-6">For more help, drop us an email at <span className=" text-blue-500"> hi@causalfunnel.com</span>.</p>
      </div>
    </div>
  );
}
